export default __webpack_public_path__ + "static/media/calendar_blue_icon.8769eae4.svg";